import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MyModal } from '../components/modal/modal';
import { ExamData, LabworkRequestModel } from '../models';
import { Api, IntakeApi, Session, Ui } from '../services/index';
import { Observable } from 'rxjs/Observable';
import { Environment } from '../app.environment';


@Component({
  selector: 'app-exam-history-patient',
  templateUrl: './exam-history-patient.html',
  styleUrls: ['./exam-history-patient.css'],
})

export class ExamHistoryPatientComponent implements OnInit {
  @ViewChild('modalPDF') public _modalPDF: MyModal;

  careInstructions: string[];
  exam: ExamData = new ExamData;
  excuseForm: any;
  intakeId: number;
  loading: boolean;
  pdf: string;
  title: string;
  visitPDF: string;
  labWork: LabworkRequestModel;

  public isRequesting: boolean;

  constructor(private api: Api,
    private intakeApi: IntakeApi,
    private route: ActivatedRoute,
    private router: Router,
    public session: Session,
    public env: Environment,
    private loader: Ui) {
    this.intakeId = this.route.snapshot.params['intakeId'] || '0';
    this.labWork = new LabworkRequestModel();
  }

  ngOnInit() {
    this.loading = true;
    this.isRequesting = true;
    let _getExcuseForm = this.api.getExcuseForm(this.intakeId).map(excuseRsult => {
      this.excuseForm = excuseRsult;
    }, ex => {
      // this.loading = false;
    });
    let _getCareInstructionsPdfLinks = this.api.getCareInstructionsPdfLinks(this.intakeId).map(careInstructionsResult => {
      this.careInstructions = careInstructionsResult;
    }, ex => {
      // this.loading = false;
    });

    let _getExamDetail = this.api.getExamDetail(this.intakeId).map(examResult => {
      this.exam = examResult;

   
    });

    let _checkPatientLabwork = this.intakeApi.checkLabworkForPatient(this.intakeId).map(labworkResults => {
      this.labWork = labworkResults.result[0];

    })


    Observable.forkJoin([_getExcuseForm,
      _getCareInstructionsPdfLinks,
      _getExamDetail,
      _checkPatientLabwork
    ]).subscribe(results => {
      if (this.exam.intakeStatus === 'CC') {
        this.api.getIntakePDF(this.intakeId).subscribe(result => {
          this.visitPDF = result;
          this.loading = false;
          this.isRequesting = false;
        }, ex => {
          this.loading = false;
          this.isRequesting = false;
        });
      }else{
        this.loading = false;
        this.isRequesting = false;
      }


    }, (error) => {
      console.log(error);
      this.loading = false;
      this.isRequesting = false;
    });

  }

  getCareDoc(title: string, pdf: string) {
    let caredocurl = "https://careinstructionsv2.s3.amazonaws.com/" + pdf;
    this.title = title;
    this.pdf = caredocurl;
    
    let docRequestUrl = caredocurl
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = docRequestUrl;

    // this.clickShowPDF(title, caredocurl);
  }

  clickShowPDF(title: string, pdf: string) {
    this.title = title;
    this.pdf = pdf;
    let docRequestUrl = pdf
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = docRequestUrl;

    //this._modalPDF.open();
  }
 
  viewLabRequest(){
    if(this.labWork.RequestStatus === 'LP' || this.labWork.RequestStatus === 'LS'){

      //once the patient clicks the button they acknoledge that they have recieved it and will print it and submit it to CC//
      this.api.updatePatienthasLabwork(this.intakeId).subscribe(res => {
        let labRequestUrl = this.env.settings.bhLabworkOrderView + this.intakeId;
        let newWindow = window.open("about:blank", "_blank");
        newWindow.opener = null;
        newWindow.location.href = labRequestUrl;
      }, (error) => {
        let labRequestUrl = this.env.settings.bhLabworkOrderView + this.intakeId;
        let newWindow = window.open("about:blank", "_blank");
        newWindow.opener = null;
        newWindow.location.href = labRequestUrl;
      });
   
    }

}

  CloseWindow(){
    this._modalPDF.close();
  }
}
